import { useEffect, useRef } from "react";
import { iosGenerateHaptic } from "../../../tools/ios";
import { HapticEffect } from "../../../interfaces";

// Fire a light haptic tick the moment the assistant starts writing — the rising
// edge of `isWriting` (first streamed text token of a turn). The ref latches the
// previous value so the tick fires exactly once per turn (false→true), then the
// latch falls back when the stream ends (true→false) ready for the next turn.
// `iosGenerateHaptic` already no-ops off-iOS and when the user disabled haptics,
// so there is nothing to guard here.
export function useFirstTokenHaptic(isWriting: boolean): void {
  const wasWriting = useRef(false);
  useEffect(() => {
    if (isWriting && !wasWriting.current)
      iosGenerateHaptic(HapticEffect.SELECTION);
    wasWriting.current = isWriting;
  }, [isWriting]);
}
